import { ShopManagerFeeSnapshot } from '@/components/Approval/@components/ShopManagerFee';
import { parseShopManagerFeeContent } from '@/utils/approval/shopManagerFee';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 157 SAP 중간 관리 수수료 정산 — 저장 content 그대로(레거시 조회와 동일) */
const ShopManagerFeeSlot = ({ data }: ContentExtraProps) => {
  const content = parseShopManagerFeeContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <ShopManagerFeeSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default ShopManagerFeeSlot;
